import React from "react";
import Routes from "./routes";

// Execução das folhas de estilos
import "./global.css";
import "./burger-menu.css";
import "./grid.css";

function App() {
  return (
    <Routes />
  );
}

export default App;
